__turbopack_context__.v({
  "container": "SecondaryPromoBoxes-module-scss-module__q-UE7q__container",
  "promoBoxLink": "SecondaryPromoBoxes-module-scss-module__q-UE7q__promoBoxLink",
  "swiper": "SecondaryPromoBoxes-module-scss-module__q-UE7q__swiper",
  "swiperSlide": "SecondaryPromoBoxes-module-scss-module__q-UE7q__swiperSlide",
  "titleContainer": "SecondaryPromoBoxes-module-scss-module__q-UE7q__titleContainer",
});
